import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {NiftyFifty, useNiftyFiftyUpdate} from 'Event/template/NiftyFifty'
import Settings from 'Event/template/NiftyFifty/Leaderboard/LeaderboardConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import {useAddTranslation} from 'Event/LanguageProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'

export default function LeaderboardConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props
  const {control, register, handleSubmit, watch, formState} = useForm()
  const updateTemplate = useNiftyFiftyUpdate()
  const addTranslation = useAddTranslation()

  const submit = (data: {
    title: string
    description: string
    points_unit: string
    menuTitle: string
    isVisible: boolean
    rewardAlert: NiftyFifty['rewardAlert']
  }) => {
    const pointUnitTitle = replaceAtPath(
      data,
      'points_unit',
      '{{points_unit_text}}',
    )

    const title = replaceAtPath(data, 'title', '{{leaderboard_title}}')

    const menuTitle = replaceAtPath(
      data,
      'menuTitle',
      '{{leaderboard_menu_title}}',
    )

    const description = replaceAtPath(
      data,
      'description',
      '{{leaderboard_description}}',
    )

    const rewardText = replaceAtPath(
      data,
      'rewardAlert.text',
      '{{reward_text}}',
    )

    const {rewardAlert, ...leaderboardData} = data

    updateTemplate({
      localization: addTranslation({
        leaderboard_title: title ?? 'Leaderboard',
        leaderboard_description: description ?? '',
        leaderboard_menuTitle: menuTitle ?? 'Points',
        points_unit: pointUnitTitle ?? 'Points',
        reward_text: rewardText ?? '',
      }),
      leaderboard: {
        ...leaderboardData,
        title: '{{leaderboard_title}}',
        description: '{{leaderboard_description}}',
        menuTitle: '{{leaderboard_menuTitle}}',
      },
      points_unit: pointUnitTitle,
      rewardAlert: {
        ...rewardAlert,
        text: '{{reward_text}}',
      },
    })

    props.onClose()
  }

  const {points_unit, ...leaderboardData} = watch()
  useAutoUpdate({
    values: {
      leaderboard: leaderboardData,
      points_unit,
    },
    when: isVisible,
  })

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Leaderboard"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} watch={watch} />
      </SettingsPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
